module.exports = __webpack_public_path__ + "img/racksnet_Logo_white-1024x299.6f9940e0.png";